import { LoaderEvent } from "../../../loader/event/LoaderEvent";
import { DestroyUtil } from "../../../util/view/DestroyUtil";
import { ViewUtils } from "../../../util/view/ViewUtils";
import { FactoryManager } from "../../factory/FactoryManager";
import { AbstractView } from "../AbstractView";
import { Background } from "./Background";
/**
 * AbstractLoader.ts
 */
export class AbstractLoader extends AbstractView {
    constructor(properties, portraitProperties, version) {
        super(properties, portraitProperties);
        this.version = version;
        this.run();
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
    }
    create() {
        super.create();
        this.createBackground();
        this.createVersionField();
        this.loadStartTime = new Date().getTime();
    }
    destroy() {
        super.destroy();
        DestroyUtil.destroy(this.background);
        this.background = null;
        DestroyUtil.destroy(this.versionField);
        this.versionField = null;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(LoaderEvent.COMPLETE, this.handleLoadingComplete);
    }
    createBackground() {
        if (this.landscapeProperties.backgroundProperties) {
            this.background = new Background(this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
            this.addChild(this.background);
        }
    }
    createVersionField() {
        this.versionField = ViewUtils.createField(this, this.landscapeProperties.versionFieldProperties, this.portraitProperties?.versionFieldProperties);
        this.versionField.setText(this.version);
    }
    updateProgress(value) { }
    handleLoadingComplete() {
        this.dispatchCore(LoaderEvent.LOADER_REMOVE);
        const endTime = new Date().getTime();
        FactoryManager.getInstance()?.getFactory()?.getModel()?.dispatchKPI("TITAN_STATE", "GAME_LOADING_PAGE_COMPLETED", (endTime - this.loadStartTime).toString());
    }
    handleResize() {
        super.handleResize();
        let rotated = this.renderer.getRotated();
        if (!rotated) {
            let safeTransform = this.renderer.getSafeTransform();
            if (this.versionField) {
                this.versionField.x = this.uiProperties.versionFieldProperties.position.x + safeTransform.x;
                this.versionField.y = this.uiProperties.versionFieldProperties.position.y + safeTransform.y;
                this.addChild(this.versionField); // Keep at top
            }
        }
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.uiProperties = this.uiProperties;
    }
}
//# sourceMappingURL=AbstractLoader.js.map